<template>
  <div class="newsitem">
    <span class="newsitem-date">{{ date }}</span>
    <div class="newsitem-body">
      <div class="newsitem-content" v-html="newsItemData.content.rendered"></div>
      <div class="newsitem-footer">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NewsItem',
  props: {
    newsItemData: {
      type: Object,
      required: true
    },
    language: {
      type: String,
      required: true
    }
  },
  computed: {
    newsItemLink() {
      const customLink = this.newsItemData.yoast_head_json.description
      if (customLink && customLink.includes('https:/')) {
        return customLink.replaceAll('$25', '%20')
      }

      return this.newsItemData.link
    },
    date() {
      return new Date(this.newsItemData.date).toLocaleDateString()
    }
  }
}
</script>

<style lang="less" scoped>
.newsitem {
  margin: 25px;

  .newsitem-date {
    color: #6C736F;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 10px;
  }

  .newsitem-title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    margin: 0 9px 10px 9px;
    color: @gray500;
  }

  .newsitem-body {
    color: black;
    padding: 0 24px 24px;
    display: inline-block;
    min-height: 150px;
    background-color: white;
    border: 1px solid @brownTerra200;
    border-radius: 4px;
    width: 100%;
  }

  .newsitem-content {
    line-height: 20px;
    font-size: 14px;
    margin-bottom: 24px;

    :deep(p) {
      font-weight: 400;
    }

    :deep(h4),
    :deep(strong) {
      font-weight: 700;
      line-height: 20px;
      font-size: 14px;
    }

    :deep(a),
    :deep(p a) {
      color: @greenTerra700;
      font-weight: 600;
      text-decoration: none;
    }
  }

  .newsitem-link {
    font-weight: bold;
    padding: 8px 14px;
    background: @white;
    color: @gray700;
    text-decoration: none;
    border: 1px solid @gray300;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 4px;
    text-align: center;
    display: inline-block;
  }

  :deep(img) {
    max-width: 100%;
    height: auto;
  }
}

.newsitem .newsitem-link:hover {
  background-color: @gray100;
}
</style>
